import React from 'react';
import { Link } from 'react-router-dom';

/* --- Icônes SVG --- */
const IconWeb = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>
);
const IconCloud = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path></svg>
);
const IconData = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
);
const IconSecurity = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
);
const IconAudit = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
);

export default function Home() {
  
  // Configuration des domaines avec couleurs spécifiques
  const units = [
    { 
      title: "Développement Web", 
      icon: <IconWeb />, 
      text: "Sites vitrines, E-commerce et applications sur-mesure performantes.", 
      color: "var(--primary)" // Rose
    },
    { 
      title: "Cloud & Infra", 
      icon: <IconCloud />, 
      text: "Hébergement sécurisé, scalable et architecture serverless.", 
      color: "#3182CE" // Bleu Tech (complémentaire)
    },
    { 
      title: "Data & I.A.", 
      icon: <IconData />, 
      text: "Valorisation de vos données et algorithmes prédictifs.", 
      color: "#805AD5" // Violet (souvent lié à l'IA)
    },
    { 
      title: "Cybersécurité", 
      icon: <IconSecurity />, 
      text: "Protection de vos actifs numériques et audits de vulnérabilité.", 
      color: "var(--accent)" // Vert
    },
    { 
      title: "Conseil & Audit", 
      icon: <IconAudit />, 
      text: "Stratégie digitale globale et optimisation des processus.", 
      color: "var(--secondary)" // Jaune
    }
  ];

  return (
    <div>
      {/* --- Hero Section --- */}
      <section className="hero">
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            {/* Titre avec classe animée conservée */}
            <h1 style={{ marginBottom: '24px' }}>
              <span className="future-text-animated" style={{ fontWeight: 700 }}>
                La solution numérique pour tous.
              </span>
            </h1>
            
            <p style={{ fontSize: '1.25rem', color: 'var(--text-grey)', marginBottom: '40px' }}>
              Nous accélérons votre transformation digitale grâce à une architecture moderne et des solutions sur‑mesure, fiables et évolutives
            </p>
            
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/services" className="btn btn-primary">Découvrir nos piliers</Link>
              <Link to="/contact" className="btn btn-outline">Nous écrire</Link>
            </div>
          </div>
        </div>
      </section>

      {/* --- Grid Section (Expertise) --- */}
      <section className="section" style={{ background: '#F9FAFB' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2>Nos Domaines d'Expertise</h2>
            <p style={{ maxWidth: '600px', margin: '15px auto', color: 'var(--text-grey)' }}>
              Une approche modulaire pour répondre précisément à vos enjeux techniques et business.
            </p>
          </div>
          
          <div className="grid-container" style={{ justifyContent: 'center' }}>
            {units.map((unit, index) => (
              <div 
                key={index} 
                className="card" 
                style={{ 
                  textAlign: 'left', // Meilleure lisibilité
                  borderTop: `4px solid ${unit.color}`, // Rappel couleur
                  display: 'flex', 
                  flexDirection: 'column'
                }}
              >
                {/* Icône colorée */}
                <div style={{ 
                  width: '60px', 
                  height: '60px', 
                  borderRadius: '50%', 
                  background: `${unit.color}15`, // Transparence 15%
                  color: unit.color, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  marginBottom: '20px',
                  fontSize: '1.5rem'
                }}>
                  {unit.icon}
                </div>

                <h3 style={{ marginBottom: '10px' }}>{unit.title}</h3>
                <p style={{ color: 'var(--text-grey)', fontSize: '0.95rem' }}>{unit.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* --- Teaser About (CTA Modernisé) --- */}
      <section className="section container">
        <div style={{ 
          background: 'linear-gradient(135deg, var(--dark) 0%, #2d3748 100%)', // Fond sombre élégant
          borderRadius: '24px',
          padding: '60px 20px',
          color: 'white',
          textAlign: 'center',
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ color: 'white', marginBottom: '20px' }}>
            L'innovation au service de votre transformation
          </h2>
          <p style={{ maxWidth: '600px', margin: '0 auto 30px', color: '#CBD5E0', fontSize: '1.1rem' }}>
            Nos équipes unissent créativité et rigueur technique pour propulser votre entreprise vers l'avenir numérique.
          </p>
          
          <Link 
            to="/le-groupe" 
            className="btn"
            style={{ 
              backgroundColor: 'white', 
              color: 'var(--dark)',
              fontWeight: '600'
            }}
          >
            En savoir plus sur nous
          </Link>
        </div>
      </section>
    </div>
  );
}